import { percentageToInches, getCoordinates } from '../helpers'
import { addSvg } from '../helpers'
import { toHtml } from 'hast-util-to-html'

/**
 *
 * SVG elements that will be transpiled needs to have proper attributes:
 * xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1"
 */
function renderInlineSvg({ x, y, height, width, parent, svgNode, slide }) {
  const coordinates = getCoordinates({ x, y }, parent)
  const imagePosition = {
    x: coordinates.x,
    y: coordinates.y,
    h: percentageToInches(height / 1080, 'y'),
    w: percentageToInches(width / 1920, 'x'),
  }

  const svgImageXML = toHtml(svgNode)
  const viewBox = svgNode.properties.viewBox

  addSvg(svgImageXML, slide, viewBox, imagePosition)
}

export default renderInlineSvg
